<template>
  <div
    class="fixed top-0 left-0 bg-black h-full w-full bg-opacity-30 md:px-60 md:pt-10 pt-2 px-4"
  >
    <div class="md:relative md:h-3/4 ">
      <!-- DEVELOPER DETAIL CARD FOR DESKTOP -->
      <div
        class="bg-blue-100 pl-8 text-left absolute left-0 top-0 fixed hidden md:block h-full w-3/12"
      >
        <img class="w-3/5  mt-10" :src="candidate.image" alt="" />
        <p class="text-purple-900 text-sm mt-2">{{ candidate.name }}</p>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs">{{ candidate.role }}</p>
        </div>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">SEX:</p>
          <p class="ml-2 text-xs">{{ candidate.sex }}</p>
        </div>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">VOTE:</p>
          <p class="ml-2 text-xs">{{ candidate.vote }}</p>
        </div>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">VOTERS:</p>
          <p class="ml-2 text-xs">{{ candidate.voters }}</p>
        </div>
      </div>

      <!-- DEVELOPERS DETAIL CARD FOR MOBILE -->
      <div class="block md:hidden bg-blue-100 text-center p-2 px-4">
        <div class="flex justify-center items-center">
          <img class="w-2/4" :src="candidate.image" alt="" />
        </div>

        <p class="text-purple-900 text-lg mt-2">{{ candidate.name }}</p>
        <div class="flex items-center justify-center mt-4">
          <i class="fas fa-unlink text-red-400"></i>
          <p class="ml-2 text-sm">{{ candidate.role }}</p>
        </div>

        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">SEX:</p>
          <p class="ml-2 text-xs">{{ candidate.sex }}</p>
        </div>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">VOTE:</p>
          <p class="ml-2 text-xs">{{ candidate.vote }}</p>
        </div>
        <div class="flex items-center justify-cent mt-4">
          <p class="ml-2 text-xs font-bold">VOTERS:</p>
          <p class="ml-2 text-xs">{{ candidate.voters }}</p>
        </div>
        <p
          @click="removeForm"
          class="mt-4 md:text-xs underline md:hidden text-purple-600"
        >
          Go Back
        </p>
      </div>

      <!-- FORM AND FORM CONTAINER -->
      <div
        class="md:absolute w-full md:top-0 md:right-0 md:h-full md:w-3/4 bg-white md:px-10 md:pb-8"
      >
        <div>
          <!-- CANCEL ICON -->
          <i
            @click="removeForm"
            class="fas fa-times-circle fa-2x absolute -top-1.5 -right-1.5 hidden md:block text-purple-600 cursor-pointer"
          ></i>
          <form class="text-left md:mt-8 md:p-0 p-4 " >
            <div class="grid grid-cols-1 md:grid-cols-1 gap-11">
              <div class="md:mb-10">
                <label
                  class="mb-2 block text-indigo-500 md:text-sm"
                  for="Number of Vote"
                  >Number of Votes</label
                >
                <input
                  class="focus:outline-none w-full block border border-indigo-500 p-4 rounded-lg"
                  type="number"
                  v-model.trim="voteCount"
                  placeholder="Enter amount of tokens to vote"
                  required
                />
              </div>
            </div>
            <div class="text-center flex md:flex-row justify-between">
              <button
                @click="voteCandidate(candidate.id)"
                type="submit"
                class="mt-10 md:mt-8 px-4 py-4 md:px-4 md:py-2 border border-indigo-600 text-white font-medium bg-indigo-600 rounded hover:text-indigo-600 hover:bg-white transition focus:outline-none md:text-sm"
              >
                VOTE NOW
              </button>
              <button
                @click="withdraw(candidate.id)"
                type="submit"
                class="mt-10 md:mt-8 px-4 py-4 md:px-4 md:py-2 border border-indigo-600 text-white font-medium bg-indigo-600 rounded hover:text-indigo-600 hover:bg-white transition focus:outline-none md:text-sm"
              >
               WITHDRAW VOTE
              </button>
              
            </div>

            <p class="mt-4 md:text-sm">
              Your vote will be casted to your favourite Candidate.
            </p>
          </form>
          <div class="mt-8 hidden md:block flex justify-between">
              <p class="font-bold text-sm mb-4">
                For Authorised Siban Admin Only
              </p>
              <button
              @click="updateVoteStatus(candidate.id)"
                v-if="voteStatus.value ==='open'"
                class="bg-red-200 text-red-400 font-bold py-2 px-8 rounded-full"
              >
                Close Vote
              </button>
              <button
               @click="updateVoteStatus(candidate.id)"
               v-if="voteStatus.value ==='closed'"
                class="bg-green-100 text-green-400 font-bold px-8 py-2 rounded-full"
              >
                Open Vote
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Signer } from "@waves/signer";
import { ProviderWeb } from "@waves.exchange/provider-web";

export default {
  props: ["candidate", "voteStatus"],
  emit: ["remove"],
  data() {
    return {
      vote: null,
      voters: null,
      voteCount: null,
      isTestnet: true,
    };
  },


  methods: {
    removeForm() {
      this.$emit("remove");
    },



    async voteCandidate(voteId) {
      if(this.voteStatus.value === 'closed'){
        alert('You cannot vote now, this candidate vote is closed')
        
      }else{
const isTestnet = this.isTestnet;
      const signer = new Signer({
        // Specify URL of the node on Testnet
        NODE_URL: isTestnet
          ? "https://nodes-testnet.wavesnodes.com"
          : "https://nodes.wavesnodes.com",
      });
      signer.setProvider(new ProviderWeb());
      const data = {
        dApp: this.dAppAddress,
        fee: 1000000,
          payment:[
            {
              assetId: "7sxG2mwboyrDvwvasCJx3saNCRQS3317THienApHNVx1",
              amount: 7,
            },
          ],
        call: {
          function: "vote",
          args: [
            { type: "string", value: voteId.split('_')[0] },
            { type: "string", value: 'upvote' },
          ],
        },
      };
      try {
        const tx = await signer.invoke(data).broadcast();
        alert("Candidate vote was successful with tx id of " + tx.id);
        this.$router.push("/home");
        // eslint-disable-next-line no-console
        console.log(tx);
      } catch (error) {
        alert(error.message);
      }
      }
      
    },


    async updateVoteStatus(id){
      const voteId = id.split('_')[0]
      const callable = this.voteStatus.value === 'open' ? 'closeVote' : 'openVote'

      const nodeUrl = this.nodeUrl
      const signer = new Signer({
        // Specify URL of the node on Testnet
        NODE_URL: nodeUrl,
      })
      signer.setProvider(new ProviderWeb())
      const data = {
        dApp: this.dAppAddress,
        call: {
          function: callable,
          args: [{ type: 'string', value: voteId }],
        },
      }
      try {
        await signer.invoke(data).broadcast()
        alert('Vote status updated successfully')
        // eslint-disable-next-line no-console
      } catch (error) {
        alert(error.message)
      }

    },

    async withdraw(voteId) {
      const isTestnet = this.isTestnet;
      const signer = new Signer({
        // Specify URL of the node on Testnet
        NODE_URL: isTestnet
          ? "https://nodes-testnet.wavesnodes.com"
          : "https://nodes.wavesnodes.com",
      });
      signer.setProvider(new ProviderWeb());
      const data = {
        dApp: this.dAppAddress,
        fee: 1000000,
        call: {
          function: "withdraw",
          args: [
            { type: "string", value: voteId.split('_')[0] },
          ],
        },
      };
      try {
         await signer.invoke(data).broadcast();
        alert("Candidate withdrawal was successful");
        this.$router.push("/home");
        // eslint-disable-next-line no-console
      } catch (error) {
        alert(error.message);
      }
    },
  },




  computed: {
    nodeUrl() {
      return this.isTestnet
        ? "https://nodes-testnet.wavesnodes.com"
        : "https://nodes.wavesplatform.com";
    },
    dAppAddress() {
      return this.isTestnet
        ? "3MsCcWZK2H5fR6xc6hJy6Mw1iaH47NWjZpg"
        : "3PPiE3H2Xrd1e5cqEs39ezVDMtRWcgJ1HgN";
    },
  },
};
</script>

<style></style>
